var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{staticClass:"mb-4 back-button",on:{"click":_vm.goBack}},[_vm._v("mdi-arrow-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }